import axios from "axios";
import anime from "animejs";
import owlCarousel from "owl.carousel";
import * as animejsPlugins from "./scrollAnimate";
//header();
let animateScroll = undefined

window.addEventListener('scroll', function () {
    header();
});


function header() {
    var scrollAtual = window.scrollY;

    if (scrollAtual !== 0) {
        jQuery("header").addClass("act");
        // Faça o que você precisa quando o scroll !assar do topo do elemento aqui
    } else {
        jQuery("header").removeClass("act");
    }
}


// Função para rolar suavemente para uma âncora
function scrollToAnchor(anchor) {
    const target = document.querySelector(anchor);
    if (target) {
        window.scrollTo({
            top: target.offsetTop - 70, // Ajuste conforme necessário para compensar o menu fixo
            behavior: 'smooth'
        });
    }
}

// Rolar para a âncora se houver um hash na URL ao carregar a página
if (window.location.hash) {
    const anchor = window.location.hash;
    scrollToAnchor(anchor);
}

// Adicionar manipuladores de evento para rolar suavemente quando clicar em links de âncora
const anchorLinks = document.querySelectorAll('a[href]');
anchorLinks.forEach(function (link) {
    const href = link.getAttribute('href');
    if (href.match(/^#[^\s]*jQuery/)) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const anchor = href.split('#')[1]; // Pegar apenas a parte da âncora
            if (document.getElementById(anchor)) {
                scrollToAnchor("#" + anchor);
            }
            return false;
        });
    }
});


let indexsd = 1;
if(jQuery(".sections").length > 0) {
    animateScroll = animejsPlugins.scrollContainer({
        sectionSelector: '.section',
        wrapperSelector: '.sections',
        duration: 800,
        easing: 'easeInOutQuad',
        onBegin: (index, anime, indexTo) => {
            if (indexTo < indexsd) {
                jQuery("header").fadeIn();
            } else {
                jQuery("header").fadeOut();
            }
            indexsd = indexTo;
        },
        onComplete: (index, anime) => {

            jQuery(".fixed-bullets span").removeClass("act");
            jQuery(".fixed-bullets span:nth-child(" + index + ")").addClass("act");
        }
    });

    jQuery(".sections section").each(function () {
        jQuery(".fixed-bullets").append("<span></span>");
    });

    jQuery(".fixed-bullets span:first-child").addClass("act");

    jQuery(".fixed-bullets span").click(function () {
        animateScroll.clickOfElement(jQuery(this).index());
    })
}


function appear(index) {

}

function disappear() {

}


let img = jQuery(".cards .card:first-child").attr("src");
let debounceTimeout;

jQuery(".cards .card").mouseenter(function () {
    clearTimeout(debounceTimeout); // Limpa o timeout anterior
    debounceTimeout = setTimeout(() => { // Inicia um novo timeout
        if(img !== jQuery(this).attr("data-img")) {
            jQuery(".cards .card").removeClass("act");
            jQuery(".switch").fadeOut(100);
            setTimeout(() => {
                jQuery(".switch").attr("src", jQuery(this).attr("data-img")).removeAttr("srcset").fadeIn(100);
            }, 100)
            jQuery(this).addClass("act");

            img = jQuery(this).attr("data-img");
        }
    }, 200); // Tempo de debounce em milissegundos
});

jQuery(".tabs a").click(function () {
    jQuery(".tabs a").removeClass("act");
    jQuery(".sde-item").removeClass("act");

    jQuery(this).addClass("act");
    jQuery("#"+ jQuery(this).attr("data-id")).addClass("act");

    return false;
});

var sd = jQuery('.owl-carousel').owlCarousel({
    nav:false,
    dots:false,
    loop:true,
    items:1,
    autoHeight:true,
});

jQuery("#next").click(function () {
    sd.trigger('next.owl.carousel');
    return false;
})

jQuery("#prev").click(function () {
    sd.trigger('prev.owl.carousel');
    return false;
})


window.addEventListener("resize", function () {
    checkIsResolution();
})

checkIsResolution();
function checkIsResolution() {
    if(jQuery(window).innerWidth() < 768 || jQuery(window).innerHeight() < 710) {
        if(animateScroll !== undefined)
        animateScroll.destroy();
        jQuery(".fixed-bullets").hide();
        jQuery(".psd").removeClass("sections");
    }
}

function convertToSlug(Text) {
    return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
}

jQuery(".options-fale .item").click(function () {
    jQuery(".options-fale .item").removeClass("act");
    jQuery("#contato").val(jQuery("h3", this).text());
    jQuery(".contactForm").attr("id", convertToSlug(jQuery("h3", this).text()));
    jQuery(".contactForm").attr("name", "New Humans | " + jQuery("h3", this).text());
    jQuery(this).addClass("act");
})

jQuery("#contato").val(jQuery(".options-fale .item.act h3").text());
jQuery(".contactForm").attr("name", "New Humans | " + (jQuery(".options-fale .item.act h3").text() ? jQuery(".options-fale .item.act h3").text() : site_url.postName));
jQuery(".contactForm").attr("id", jQuery(".options-fale .item.act h3").text() ? convertToSlug(jQuery(".options-fale .item.act h3").text()) : convertToSlug(site_url.postName));

jQuery(".menu-mobile").click(function () {
    jQuery(".menu-mobile-container").toggleClass("act");
});

if(jQuery(".contactForm").length > 0)
document.querySelector('.contactForm').addEventListener('submit', function(event) {
    event.preventDefault(); // Impedir o envio do formulário padrão
    jQuery(".abs-loading").fadeIn();
    // Obter os valores dos campos do formulário
    const nome = document.getElementById('nome').value;
    const email = document.getElementById('email').value;
    const empresa = document.getElementById('empresa').value;
    const telefone = document.getElementById('telefone').value;
    const mensagem = document.getElementById('mensagem').value;
    const contato = jQuery("#contato").length > 0 ? document.getElementById('contato').value : "";
    const chleba_lead_id = document.getElementById("chleba_lead_id").value;


    // Criar o objeto de dados para enviar
    const data = {
        nome: nome,
        email: email,
        empresa: empresa,
        telefone: telefone,
        mensagem: mensagem,
        contato: contato,
        site_url : window.location.href
    };

    var image = document.createElement("img");


    // Enviar a solicitação POST para o endpoint
    axios.post(site_url.url + '/wp-json/wp/v2/postContato', data)
        .then(function(response) {
            // fbq('track', 'Lead');
            //gtag('event', 'conversion', {'send_to': 'AW-1069799963/KMBFCNT6_KYBEJu0j_4D'});
            image.src = "https://servico.addintelligence.com.br/contentserver/NewHumans.cli/CustRel.aspx?canal=Fale_Conosco&subcanal="+contato+"@"+email+"@"+nome+"@"+empresa+"&servico=Site@"+chleba_lead_id+"&tiporel=60";
            document.body.append(image);
            //var imageLinkedin = document.createElement('img');
            //imageLinkedin.src="https://dc.ads.linkedin.com/collect/?pid=85614&conversionId=374577&fmt=gif"
            jQuery(".abs-loading").fadeOut();
            alert('Formulário enviado com sucesso!');
            document.querySelector('.contactForm').reset();
        })
        .catch(function(error) {
            console.error(error);
            jQuery(".abs-loading").fadeOut();
            alert('Houve um erro ao enviar o formulário. Por favor, tente novamente.');
            document.querySelector('.contactForm').reset();
        });
});

